// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"iq-z","summaryPar":"jq-z","ratingCategories":"kq-z","reviewerInfo":"lq-z","reviewTypes":"mq-z","expanded":"nq-z"};